export default {
    SET_USERS(state, users) {
        state.users = users
    },
    ADD_USER(state, user) {
        state.users.unshift(user)
    },
    UPDATE_USER(state, user) {
        const userIndex = state.users.findIndex((u) => u.id === user.id)
        Object.assign(state.users[userIndex], user)
    },
    DELETE_USER(state, userId) {
        const ItemIndex = state.users.findIndex((u) => u.id === userId)
        state.users.splice(ItemIndex, 1)
    },
    SET_ORIGINAL_USER_BEARER(state, bearer) {
        state.userInfos.originalBearer = bearer
    },
    SET_ORIGINAL_USER(state, user) {
        const bearer = state.userInfos.originalBearer
        state.userInfos = user
        state.userInfos.originalBearer = bearer
        state.isOriginalUser = false
    }
}
